

const reportOne        = require ('./purchase-report-one')

export function start(detail){  ///console.log('purchase report', detail)
         
      obj[detail.reportType].start(detail)

}/**/




const obj = {
   
      reportOne:  { start: (detail)=>{  reportOne.start(detail)  }},


}


